module.exports = __webpack_public_path__ + "static/media/mask.b8605cae.png";